export class DSOrganisationProjectTemplate {
  /**
   * JSON template
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  projectTemplate: any;

  /**
   * DSOrganisationProjectTemplate constructor.
   *
   * @param json template
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(json: any) {
    this.projectTemplate = json;
  }
}
